export default function(location) {
  if (typeof location === "undefined") {
    return null;
  }
  return `${location.prefecture}${location.municipality}${location.address}${location.building_name}`;
}
